<button *ngIf="isEditMode" class="btn btn-primary" type="button" (click)="openAddCompany(addCompany);">Add Company</button>

<ng-template #addCompany let-modal>
    <div class="modal-header">
        <h4 class="modal-title text-gray-600" id="modal-basic-title">Add Company To User</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="addCompanyFrom">
        <div class="modal-body">
            <error-message [errors]="errors"></error-message>

            <div class="row form-group">
                <div class="col-lg-6">
                    <div class="form-group">
                        <label class="col-form-label">Companies</label>
                        <select name="title" class="form-select" formControlName="companyId">
                            <option *ngFor="let company of companies" [value]="company.id">{{ company.legalName }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="form-group">
                        <label class="col-form-label">User Type</label>
                        <select name="userTypeId" class="form-select" formControlName="userTypeId">
                            <option *ngFor="let userType of userTypes" [value]="userType.id">{{ userType.description}}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <div class="row">
                <div class="col-md-12 text-end">
                    <button type="button" class="btn btn-outline-primary modal-dismiss me-1" (click)="modal.close('Close');">Cancel</button>
                    <button type="button" class="btn btn-success modal-dismiss" (click)="addCompanyToUser();" [disabled]="submitAttempt">Ok</button>
                </div>
            </div>
        </div>
    </form>
</ng-template>
